/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Relationship } from './relationship';


export interface ExpandedPermissionTree { 
    /**
     * The children of the node, possibly none.
     */
    children?: Array<ExpandedPermissionTree>;
    tuple?: Relationship;
    /**
     * The type of the node. union TreeNodeUnion exclusion TreeNodeExclusion intersection TreeNodeIntersection leaf TreeNodeLeaf tuple_to_subject_set TreeNodeTupleToSubjectSet computed_subject_set TreeNodeComputedSubjectSet not TreeNodeNot unspecified TreeNodeUnspecified
     */
    type: ExpandedPermissionTree.TypeEnum;
}
export namespace ExpandedPermissionTree {
    export type TypeEnum = 'union' | 'exclusion' | 'intersection' | 'leaf' | 'tuple_to_subject_set' | 'computed_subject_set' | 'not' | 'unspecified';
    export const TypeEnum = {
        Union: 'union' as TypeEnum,
        Exclusion: 'exclusion' as TypeEnum,
        Intersection: 'intersection' as TypeEnum,
        Leaf: 'leaf' as TypeEnum,
        TupleToSubjectSet: 'tuple_to_subject_set' as TypeEnum,
        ComputedSubjectSet: 'computed_subject_set' as TypeEnum,
        Not: 'not' as TypeEnum,
        Unspecified: 'unspecified' as TypeEnum
    };
}


